import React from 'react';
import { useSelector } from 'react-redux';
import { Empty } from 'antd';
import { useFieldArrayState } from '../../../../helpers/formManager';
import Item from './components/Item';
import { types, props } from './constants';
import DeskProxyProvider from './providers/desksProxyProvider';

const providers = {
  [types.desk]: DeskProxyProvider,
};

const FieldArraySelector = ({ type }) => {
  const fields = useFieldArrayState();

  if (!fields.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={props[type].emptyDesc}
      />
    );
  }

  return <Content fields={fields} type={type} />;
};

FieldArraySelector.types = types;

export default FieldArraySelector;

function Content({ fields, type }) {
  const { activeIndexSelector, changeAction, icon } = props[type];

  const activeIndex = useSelector(activeIndexSelector);

  const Provider = providers[type];

  return fields.map((field, index) => (
    <Provider key={field.key} index={index}>
      <Item
        changeAction={changeAction}
        isActive={index === activeIndex}
        entityKey={field.key}
        icon={icon}
      />
    </Provider>
  ));
}
